import createRetryAxios from './axiosRetry'
import { getToken } from '../../auth/auth'
import { removeODataContext } from '../utils'
import { getListItem, getDriveItemListItemDetail } from './index'
import { getSiteConfig } from '../../community/siteProvider'

// limit to site path with OR
// "queryString": "An old article path:\"https://groups.coca-cola.com/sites/NAOUQSE/safety_nonprod\" OR path:\"https://groups.coca-cola.com/sites/Coca-Cola-Lens\""
const getAccessToken = async () => {
  return window.sessionStorage.mockGraphToken ?? (await getToken()).accessToken
}

export const siteSearch = async (query) => {
  const token = await getAccessToken()
  const promises = [
    searchArticles(query, token),
    searchDocuments(query, token),
  ]
  const [articles, documents] = await Promise.all(promises)
  return [...articles, ...documents]
}

export const searchArticles = async (query, _token) => {
  const { urls } = getSiteConfig()
  const token = _token ?? await getAccessToken()
  const url = `https://graph.microsoft.com/v1.0/search/query`
  const body = {
    "requests": [
      {
        "entityTypes": [
          "listItem"
        ],
        "query": {
          "queryString": `${query}* path:"${urls.baseSite}/SitePages" AND NOT path:"${urls.baseSite}/SitePages/Templates"`
        }
      }
    ]
  }
  const response = await createRetryAxios().post(url, body, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  const data = response?.data
  if(!data) return []
  const _results = data?.value?.[0]?.hitsContainers?.[0]?.hits || []
  const detailPromises = _results.map(async result => {
    const listItemDetail = await getListItem(result.resource.sharepointIds.listId, result.resource.sharepointIds.listItemId, ['fields'])
    return { ...listItemDetail, ...result, qsePortalHitType: 'article' }
  })
  const results = await Promise.all(detailPromises)
  return results
}

export const searchDocuments = async (query, token) => {
  const { urls } = getSiteConfig()
  const url = `https://graph.microsoft.com/v1.0/search/query`
  const body = {
    "requests": [
      {
        "entityTypes": [
          "driveItem"
        ],
        "query": {
          "queryString": `${query} path:"${urls.baseSite}/Shared Documents/" AND ParentLink:\"/Published\"`
        }
      }
    ]
  }
  const response = await createRetryAxios().post(url, body, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  const data = response?.data
  if(!data) return []

  const _results = data?.value?.[0]?.hitsContainers?.[0]?.hits || []
  const detailPromises = _results.map(async result => {
    const detail = await getDriveItemListItemDetail(
      result.resource.parentReference.sharepointIds.listId,
      result.resource.parentReference.sharepointIds.listItemUniqueId
    )
    return { ...detail, ...result, qsePortalHitType: 'document' }
  })
  const results = await Promise.all(detailPromises)
  return results
}
